import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  padding-top: ${(props) => (props.$padding ? props.$padding : "56.2%")};
  position: relative;

  > * {
    bottom: 0;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`

const ResponsiveWrapper = ({ children, padding }) => (
  <Container $padding={padding}>{children}</Container>
)

ResponsiveWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.string,
}

export default ResponsiveWrapper
